import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';

const INIT_USER_PERMISSION = 'userPermissionACtion/initUserPermission';
const UPDATE_USER_PERMISSION = 'userPermissionACtion/updateUserPermission';

export const initUserPermission = createAction(INIT_USER_PERMISSION);
export const updateUserPermission = createAction(UPDATE_USER_PERMISSION);

const initialState = {
    matching: false
}

export default handleActions({
    [INIT_USER_PERMISSION]: (state, action) => {
        return produce(state, draft => {
            draft.matching = false; 
        });
    },
    [UPDATE_USER_PERMISSION]: (state, action) => {
        return produce(state, draft => {
            draft.matching = (action.payload.matching !== undefined || action.payload.matching !== null) ? action.payload.matching : draft.matching; 
        });
    },
}, initialState)